import { NavDrawer as Drawer } from 'header'
import { useDispatch } from 'react-redux'

import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { closeMobileNav, useIsMobileNavOpen } from '~map-preview/states/ui'

export function NavDrawer() {
  const dispatch = useDispatch()
  const open = useIsMobileNavOpen()
  const isEmbed = useIsEmbed()

  const handleClose = () => {
    dispatch(closeMobileNav())
  }

  return (
    <Drawer
      disablePortal
      sx={{
        position: 'absolute'
      }}
      PaperProps={{
        sx: [
          {
            position: 'absolute',
            width: 380
          },
          (theme) => ({
            [theme.breakpoints.down('mobile')]: {
              width: isEmbed ? 'calc(100% - 80px)' : '100%',
              height: '100dvh'
              // height: 'calc(100dvh - var(--sidebar-offset-bottom, 0px))'
            }
          })
        ]
      }}
      open={open}
      onClose={handleClose}
    />
  )
}
